export const ENDPOINTS = {
  login: '/auth/login',
  user: '/users',
  changePassword: '/users/change-password'
};
